// import * as queryString from 'querystring';

import { getConfig } from '../config';
import { AppState, store } from '../store';
import { push } from 'redux-first-history';
import * as productActions from '../store/products/actions';

// notices need to be cleared on any user click
document.addEventListener('click', function (evnt) {
  const state = store.getState() as unknown as AppState;
  const notices = Object.keys(state.products.notices).length;
  if (notices) {
    store.dispatch({ type: 'CLEAR_NOTICES' });
  }
});

export const wrap = (fn: (dispatch: any, getState?: any) => Promise<any>, type = ''): any => {
  return function (dispatch: any, getState?: any) {
    return fn(dispatch, getState).catch((error) => {
      if (!String(error as any).includes('The user aborted a request')) {
        try {
          let errorJson = JSON.parse(error);
          dispatch({ type, payload: errorJson });
        } catch (e) {
          return e;
        }
      }
    });
  };
};

let apiUrl = getConfig('apiUrl');

export default function apiCaller<T>(
  method: string,
  path: string,
  data?: any,
  headers?: object,
  signal?: AbortSignal,
): Promise<any> {
  let keycloakToken = null;
  let keycloakRefreshToken = null;
  if (store.getState().keycloak.tokens) {
    // @ts-ignore
    keycloakToken = store.getState().keycloak.tokens.token;
    // @ts-ignore
    keycloakRefreshToken = store.getState().keycloak.tokens.refreshToken;
  }
  const apiToken = keycloakToken || (window as any).sessionStorage.getItem('bearerTokenEC');
  const refreshToken = keycloakRefreshToken || (window as any).sessionStorage.getItem('refreshTokenEC');

  const langCode = store.getState().intl.locale;
  let apiObject = {
    method: method.split('_')[0],
    headers: {
      'Content-Type': 'application/json',
      'accept-language-master': langCode || 'de',
      'Easy-Mode': 'module_digitalcalculator',
      'X-Process-Token': (window as any).clientHash,
      ...(apiToken && {
        Authorization: `Bearer ${apiToken}`,
      }),
      ...(refreshToken && {
        'Authorization-Refresh': refreshToken,
      }),
      ...headers,
    },
    body: null,
  };

  if (signal) {
    // @ts-ignore
    apiObject['signal'] = signal;
  }

  if (method === 'POST_MULTIPART') {
    apiObject.body = data;
  } else if (method === 'POST' || method === 'PUT' || method === 'PATCH' || method === 'DELETE') {
    // @ts-ignore
    apiObject.body = data ? JSON.stringify(data) : null;
  }

  if (method === 'POST_MULTIPART') {
    delete apiObject.headers['Content-Type'];
  }

  return fetch(apiUrl + path, apiObject)
    .then((res) => {
      const setToken = res.headers.get('set-token');
      const setRefreshtoken = res.headers.get('set-refreshtoken');

      setToken && (window as any).sessionStorage.setItem('bearerTokenEC', setToken);
      setRefreshtoken && (window as any).sessionStorage.setItem('refreshTokenEC', setRefreshtoken);
      // sometimes errors come in 200 responses
      if (res.ok) {
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.indexOf('application/json') !== -1) {
          return res.json().then((responseJson) => {
            if (responseJson.error) {
              throw JSON.stringify({
                details: responseJson.error.messages, //  + (responseJson.error.code ? " at " + responseJson.error.class : "")
                status: res.status,
                code: responseJson.error.code,
                class: responseJson.error.class,
              });
            } else if (responseJson.notices.length) {
              responseJson.notices.forEach((notice) => {
                // Exceptions list for notices
                if ([2111, 2112, 2102, 2101, 1021, 1022].includes(notice.code) && notice.code) {
                  let productUrn;

                  // Attempt to extract productUrn from the URL query parameters
                  if (path.includes('priceforproduct?') || path.includes('calculateshareoftime?')) {
                    const queryParams = new URLSearchParams(path.split('?')[1]);
                    productUrn = queryParams.get('producturn');
                  } else if (data instanceof FormData && data.has('producturn')) {
                    productUrn = data.get('producturn');
                  }

                  if (productUrn) {
                    const queryParams = new URLSearchParams(path.split('?')[1]);
                    const subProductUrn = queryParams.get('subproducturn');
                    store.dispatch(
                      productActions.receivedNotice({
                        ...notice,
                        status: res.status,
                        data: responseJson?.data,
                        productUrn: subProductUrn || productUrn,
                      }),
                    );
                  } else {
                    console.error('No productUrn found');
                  }
                }
              });

              if (
                responseJson.data.length === 0 &&
                responseJson.notices.length === 0 &&
                path !== 'startpaymentprocess'
              ) {
                const notices = responseJson.notices.join('\n');
                throw JSON.stringify({
                  details: notices,
                  status: res.status,
                  code: res.status,
                });
              } else {
                return Promise.resolve(responseJson);
              }
            } else {
              return Promise.resolve(responseJson);
            }
          });
        } else if (
          contentType &&
          (contentType.includes('application/xlsx') ||
            contentType.includes('application/csv') ||
            contentType.includes('application/pdf'))
        ) {
          return res.blob();
        } else {
          return 'OK';
        }
      }
      // all other, non 200 responses
      return res.json().then((responseJson) => {
        console.log('apiCaller error json: ', responseJson.error);
        if (responseJson.error?.class === 'MicroserviceUsageCore\\Domain\\Exception\\RelocateException') {
          if (responseJson.error.code === 1001 && (window as any).keycloakReady) {
            window.location.href = (window as any).keycloak.createLoginUrl();
          } else if (responseJson.error.code === 1002) {
            window.location.href = responseJson.error.additionalinfo;
          } else {
            // scrollToTop();
            throw JSON.stringify({
              details: responseJson.error.message, // + (responseJson.error.class ? " at " + responseJson.error.class : ""),
              status: res.status,
              code: responseJson.error.code,
              additionalInfo: responseJson.error.additionalInfo,
            });
          }
        } else {
          if (responseJson.error) {
            // scrollToTop();
            if (
              (responseJson.error.code === 1000 ||
                responseJson.error.code === 1001 ||
                responseJson.error?.class === 'MicroserviceUsageCore\\Domain\\Exception\\ParameterException') &&
              (window as any).keycloakReady &&
              responseJson.error?.class !== 'App\\Shop\\Domain\\Exception\\BasketValidationException'
            ) {
              store.dispatch(
                push({
                  search: `?error=true`,
                }),
              );
            }
            throw JSON.stringify({
              details: responseJson.error.message, // + (responseJson.error.code ? " at " + responseJson.error.class : ""),
              status: res.status,
              code: responseJson.error.code,
              class: responseJson.error.class,
            });
          } else {
            throw JSON.stringify(responseJson);
          }
        }
      });
    })
    .catch((error) => {
      if (error.name === 'AbortError') {
        console.log('Fetch request was cancelled');
        return null;
      }
      throw error;
    });
}
